export const PASSENGER_TYPE = {
  ADULT: 'adult',
  SENIOR: 'senior',
  CHILD: 'child',
  PET: 'pet'
}

export const TYPE = {
  PASSENGER: 'passengerType'
}
